import React from 'react';
import LabeledHorizontalPlotContainer from '../labeled-horizontal-plot-container';
import LabeledHorizontalPlot from '../labeled-horizontal-plot';
import {aboveBelowAverage} from 'shared/college-profile/utils';
import {withCommas} from 'shared/utils';
import {NationalCollegeData} from 'src/types/college-profile';

interface Props {
  label: string;
  tooltip: React.ReactNode;
  dataSource: NationalCollegeData;
  attributeOnCollege: string;
  attributeInSource: string;
  college: Record<string, number>;
}

const CostComparisonWithAverage = ({
  label,
  tooltip,
  dataSource,
  attributeOnCollege,
  attributeInSource,
  college,
}: Props) => {
  const value = college[attributeOnCollege];

  if (!value) {
    return null;
  }

  const average = dataSource[attributeInSource]['median'];
  const averageCost = `$${withCommas(average)}`;
  const min = dataSource[attributeInSource]['min'];
  const max = dataSource[attributeInSource]['max'];

  return (
    <div className="college-profile-cost-comparison">
      <p className="college-profile-cost-comparison-label-text">{label}</p>
      {tooltip && tooltip}
      <div
        aria-label={`${label} $${withCommas(
          value
        )} as compared to the national average ${averageCost}`}
      >
        <LabeledHorizontalPlotContainer value={value} subtext={aboveBelowAverage(value, average)}>
          <LabeledHorizontalPlot
            labelText={`${averageCost} Nat'l Avg`}
            labelValue={average}
            max={max}
            min={min}
            value={value}
          />
        </LabeledHorizontalPlotContainer>
      </div>
    </div>
  );
};

export default CostComparisonWithAverage;
